var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.357 30.7465L24.7249 28.3313L23.9054 28.3116H19.9922L22.7117 10.4888C22.7202 10.4349 22.7476 10.3848 22.7876 10.3491C22.8278 10.3135 22.879 10.2939 22.9326 10.2939H29.5309C31.7216 10.2939 33.2333 10.765 34.0225 11.6949C34.3925 12.1311 34.6282 12.5871 34.7423 13.0887C34.8619 13.6152 34.8638 14.2441 34.7472 15.0113L34.7387 15.0671V15.5587L35.1087 15.7754C35.4203 15.9463 35.6679 16.1418 35.8579 16.3656C36.1743 16.7387 36.3791 17.2128 36.4656 17.7747C36.555 18.3527 36.5255 19.0406 36.3791 19.8194C36.2102 20.7151 35.9373 21.4953 35.5686 22.1336C35.2297 22.7218 34.7978 23.2097 34.2849 23.5877C33.7953 23.947 33.2136 24.2197 32.5559 24.3942C31.9185 24.5657 31.1918 24.6522 30.3947 24.6522H29.8813C29.5142 24.6522 29.1575 24.7889 28.8775 25.0339C28.5968 25.284 28.4111 25.6257 28.3542 25.9994L28.3154 26.2169L27.6653 30.474L27.636 30.6302C27.6281 30.6797 27.6147 30.7043 27.595 30.721C27.5775 30.7363 27.5522 30.7465 27.5276 30.7465H24.357",
    fill: "#28356A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4575 15.124C35.438 15.2542 35.4153 15.3871 35.3901 15.5238C34.52 20.1415 31.5429 21.7368 27.7408 21.7368H25.8049C25.3399 21.7368 24.948 22.0857 24.8756 22.5598L23.6037 30.8985C23.5567 31.2099 23.7888 31.4904 24.0926 31.4904H27.5262C27.9327 31.4904 28.2781 31.1851 28.3422 30.7706L28.3759 30.5904L29.0224 26.35L29.0639 26.1175C29.1272 25.7016 29.4734 25.3961 29.8799 25.3961H30.3934C33.72 25.3961 36.3243 24.0002 37.0855 19.9605C37.4033 18.273 37.2388 16.8639 36.3974 15.8729C36.1428 15.5741 35.827 15.3261 35.4575 15.124",
    fill: "#298FC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5506 14.7496C34.4176 14.7094 34.2805 14.6732 34.1398 14.6404C33.9983 14.6084 33.8535 14.5801 33.7044 14.5553C33.1824 14.4681 32.6104 14.4268 31.9978 14.4268H26.8261C26.6986 14.4268 26.5776 14.4565 26.4694 14.5103C26.2308 14.6288 26.0537 14.8622 26.0107 15.1479L24.9104 22.3505L24.8789 22.5604C24.9512 22.0863 25.3431 21.7375 25.8081 21.7375H27.7441C31.5462 21.7375 34.5233 20.1414 35.3934 15.5245C35.4194 15.3878 35.4413 15.2548 35.4608 15.1247C35.2407 15.0039 35.0023 14.9007 34.7455 14.8127C34.6821 14.7909 34.6167 14.7699 34.5506 14.7496",
    fill: "#22284F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0091 15.1475C26.052 14.8618 26.2292 14.6284 26.4678 14.5107C26.5767 14.4567 26.6969 14.427 26.8244 14.427H31.9961C32.6087 14.427 33.1807 14.4685 33.7027 14.5557C33.8519 14.5804 33.9967 14.6089 34.1382 14.6408C34.2788 14.6734 34.416 14.7099 34.549 14.7498C34.615 14.7702 34.6804 14.7913 34.7445 14.8123C35.0012 14.9003 35.2398 15.0044 35.4599 15.1243C35.7188 13.4179 35.4577 12.256 34.5651 11.2039C33.5809 10.0455 31.8048 9.5498 29.5319 9.5498H22.9335C22.4692 9.5498 22.0732 9.89867 22.0014 10.3736L19.2531 28.3796C19.1989 28.7358 19.4647 29.0572 19.8123 29.0572H23.8859L26.0091 15.1475",
    fill: "#28356A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "var(--input-border)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.a5359dd70f3c6e10653c0f9ca9837161.svg";
export { ForwardRef as ReactComponent };